import { AvatarUpload } from '../../../../../components/ui-kit/AvatarUpload'
import { GRID_FORM_CONFIG_T } from '../../../../../common/FormGenerator'

export type FiltrationBlockName = 'cover'

export type CoverUploadFieldProps = {
  onCropSaved?: (file: File) => Promise<string | void>
  hideRemove?: boolean
}

export const coverConfig = (
  coverUploadProps: CoverUploadFieldProps = {},
): GRID_FORM_CONFIG_T<{ coverUrl: string | File | null }> => [
  [
    {
      id: 1,
      controllerName: 'coverUrl',
      RenderElement: AvatarUpload,
      renderProps: () => coverUploadProps,
    },
  ],
]

export const getFormConfig = (
  blockName: FiltrationBlockName,
  coverUploadProps?: CoverUploadFieldProps,
) => {
  if (blockName === 'cover') {
    return coverConfig(coverUploadProps)
  }
  return []
}
